export const GET_KONSULTAN='GET_KONSULTAN'
export const GET_KONSULTAN_DROPDOWN='GET_KONSULTAN_DROPDOWN'
export const RESET_DETAIL='RESET_DETAIL'
export const SET_KONSULTAN_DETAIL='SET_KONSULTAN_DETAIL'